import { API, setTrackLink } from '@vfit/shared/data-access';
import { CONSUMER_CMS_ABROAD, useCmsConfig } from '@vfit/consumer/data-access';
import { useTracking } from '@vfit/shared/data-access';
import React, { useEffect } from 'react';
import MainContainer from '../../components/MainContainer/mainContainer';
import { getTagging } from '../../components/MainContainer/mainContainer.utils';
import { useTagging } from '../../hooks/useTagging';
import WidgetWrapper from '../../components/WidgetWrapper/widgetWrapper';
import { useConsumerAbroad } from '../templates.hook';
import { useUserContext } from '../../context/user/user.context';
import { useUserInfo } from '../../components/MainContainer/mainContainer.hook';

export default function Landing() {
  const { items, activable, identify } = useUserContext();
  const aemData = useCmsConfig(CONSUMER_CMS_ABROAD, API.CMS_ABROAD_GET_HOME_V2);
  const isLoading = items?.isLoading || activable?.isLoading || identify?.isLoading || false;
  const { aemElements } = useConsumerAbroad(aemData, isLoading);
  const tagging = getTagging('estero', 'task', 'landing');
  const visitorTrackingOpts = useUserInfo();
  const { trackView, isReadyTrackView } = useTracking({
    event: ['view'],
    event_label: 'estero',
    opts: { ...tagging.opts, page_type: 'snodo' },
    visitorTrackingOpts,
  });

  useTagging();

  useEffect(() => {
    if (isReadyTrackView) setTrackLink(trackView);
  }, [isReadyTrackView]);

  return (
    <MainContainer>
      <WidgetWrapper aemElements={aemElements} />
    </MainContainer>
  );
}
